import { lighten, Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

type StatusOptionStylesProps = {
  colour?: string
}

const useStyles = makeStyles<Theme, StatusOptionStylesProps>(theme => ({
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 8,
    flexShrink: 0,
    backgroundColor: ({ colour }) => (colour ? `#${colour}` : 'white'),
    border: ({ colour }) => (colour ? `` : 'solid 1px black')
  },
  foundRoot: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '90%',
    borderRadius: 12,
    padding: '3px 6px',
    backgroundColor: ({ colour }) =>
      colour ? lighten(`#${colour}`, 0.8) : 'white',
    '& label': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  }
}))

export default useStyles
